import { render } from "./QuizQuestionsList.vue?vue&type=template&id=23af52fa&scoped=true"
import script from "./QuizQuestionsList.vue?vue&type=script&lang=js"
export * from "./QuizQuestionsList.vue?vue&type=script&lang=js"

import "./QuizQuestionsList.vue?vue&type=style&index=0&id=23af52fa&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23af52fa"]])

export default __exports__